export const SCHEDULING_TYPES_FORM = "configOpportunitySchedulingTypes";